import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseContactApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    if (params?.userEmail) {
      config.headers = {
        ...config.headers,
        'HAMS-Impersonated-Contact-Email': params.userEmail,
      };
    } else if (!remainingPath.includes('isMemberOf')) {
      config.headers = {
        ...config.headers,
        ...impersonationHeader,
      };
    }
    return (await hamsClient.get(`${baseContactApiUrl}${remainingPath}`, config)).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
